import { Link, useSearchParams } from 'react-router-dom';
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import '../PagamentoConcluido/index.scss';

export default function PagamentoFalhou() {
    const [searchParams] = useSearchParams();
    const orderNsu = searchParams.get('order_nsu') || '';

    return (
        <section className='container-pagamento-resultado falhou'>
            <Cabecalho />
            <main>
                <div className='palco-status'>
                    <div className='fundo-status-svg' aria-hidden='true'>
                        <svg className='orb orb-1' viewBox='0 0 120 120'><circle cx='60' cy='60' r='60' /></svg>
                        <svg className='orb orb-2' viewBox='0 0 80 80'><circle cx='40' cy='40' r='40' /></svg>
                        <svg className='orb orb-3' viewBox='0 0 150 150'><circle cx='75' cy='75' r='75' /></svg>
                        <svg className='orb orb-4' viewBox='0 0 95 95'><circle cx='47.5' cy='47.5' r='47.5' /></svg>
                        <svg className='orb orb-5' viewBox='0 0 180 180'><circle cx='90' cy='90' r='90' /></svg>
                        <svg className='orb orb-6' viewBox='0 0 62 62'><circle cx='31' cy='31' r='31' /></svg>
                    </div>

                    <div className='icon'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.9987 11.1654L5.91536 15.2487C5.76259 15.4015 5.56814 15.4779 5.33203 15.4779C5.09592 15.4779 4.90148 15.4015 4.7487 15.2487C4.59592 15.0959 4.51953 14.9015 4.51953 14.6654C4.51953 14.4293 4.59592 14.2348 4.7487 14.082L8.83203 9.9987L4.7487 5.91536C4.59592 5.76259 4.51953 5.56814 4.51953 5.33203C4.51953 5.09592 4.59592 4.90148 4.7487 4.7487C4.90148 4.59592 5.09592 4.51953 5.33203 4.51953C5.56814 4.51953 5.76259 4.59592 5.91536 4.7487L9.9987 8.83203L14.082 4.7487C14.2348 4.59592 14.4293 4.51953 14.6654 4.51953C14.9015 4.51953 15.0959 4.59592 15.2487 4.7487C15.4015 4.90148 15.4779 5.09592 15.4779 5.33203C15.4779 5.56814 15.4015 5.76259 15.2487 5.91536L11.1654 9.9987L15.2487 14.082C15.4015 14.2348 15.4779 14.4293 15.4779 14.6654C15.4779 14.9015 15.4015 15.0959 15.2487 15.2487C15.0959 15.4015 14.9015 15.4779 14.6654 15.4779C14.4293 15.4779 14.2348 15.4015 14.082 15.2487L9.9987 11.1654Z" fill="#FF0000"/>
</svg>
</div>
                    <h1>Nao foi possivel confirmar seu pagamento</h1>
                    <p>Voce pode tentar novamente pelo seu pedido ou escolher outro metodo.</p>
                    <div className='detalhes'>
                        <p className='numero-metodo'>
                            <span className='label'>Pedido:</span>
                            <strong>{orderNsu || 'Nao informado'}</strong>
                        </p>
                    </div>
                    <div className='acoes'>
                        <Link to='/menu/perfil/meuspedidos' className='btn primario'>Ir para meus pedidos</Link>
                        <Link to='/checkout' className='btn secundario'>Voltar ao checkout</Link>
                    </div>
                </div>
            </main>
            <Rodape />
        </section>
    );
}
